import { computed } from "vue"
import { useUserAccountsStore } from "../stores/userAccounts"

const userAccount = computed(() => useUserAccountsStore().userAccount)
const userPlan = computed(() => useUserAccountsStore().userPlan)

const validRoutes = {
  expired: ["select-plan-to-continue", "checkout"],
  withoutFirstQr: ["qr-builder"]
}

const defaultRoutes = {
  expired: { name: "select-plan-to-continue" },
  withoutFirstQr: {
    name: "qr-builder",
    params: { action: "create" }
  }
}

export default function useAccountChecker() {
  const accountSubscriptionIsPremium = computed(
    () => userAccount.value?.subscriptionTypeDescription === "PREMIUM"
  )
  const accountSubscriptionIsDemo = computed(() => userPlan.value?.isDemo)
  const accountSubscriptionIsStarter = computed(() => userPlan.value?.name === "starter")

  const accountSubscriptionIsEnterprise = computed(
    () => userAccount.value?.subscriptionTypeDescription === "ENTERPRISE"
  )
  const accountSubscriptionIsFree = computed(
    () => userAccount.value?.subscriptionTypeDescription === "FREE"
  )
  const accountSubscriptionIsCancelled = computed(
    () => userAccount.value?.subscriptionStatusDescription === "CANCELLED"
  )
  const accountSubscriptionIsExpired = computed(
    () => userAccount.value?.subscriptionStatusDescription === "EXPIRED"
  )

  const accountHasCreatedFirstQr = computed(() => userAccount.value?.hasCreatedFirstQr)

  function canAccessRoute(to, from, next) {
    if (from?.name == "sign-up" && to.name != defaultRoutes["withoutFirstQr"].name)
      next(defaultRoutes["withoutFirstQr"])
    else if (accountSubscriptionIsExpired.value && !validRoutes["expired"].includes(to.name))
      next(defaultRoutes["expired"])
    else next()
  }

  function isLimitReached(feature) {
    return userPlan.value?.features?.limits
      ? userPlan.value?.features?.limits[feature] === userAccount.value?.totals[feature]
      : true
  }

  return {
    accountSubscriptionIsPremium,
    accountSubscriptionIsFree,
    accountSubscriptionIsCancelled,
    accountSubscriptionIsExpired,
    accountSubscriptionIsEnterprise,
    accountHasCreatedFirstQr,
    accountSubscriptionIsDemo,
    accountSubscriptionIsStarter,
    canAccessRoute,
    isLimitReached
  }
}
